const slider = {
    getList: 'BlogBanner/getlist-by-admin',
    add: 'BlogBanner/add',
    edit: 'BlogBanner/update',
    get: 'BlogBanner/get',
    remove: 'BlogBanner/remove',
    getAll: 'BlogBanner/getall'
}

export default slider